import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TopUpService {

  private readonly httpReqOptions = { withCredentials: true };

  constructor(private httpClient: HttpClient) {}

  public getTopUpBalance(): Observable<number | null> {
    const url = `${environment.apiUrl}/refund/checkout/balance`;
    return this.httpClient.get<number | null>(url, this.httpReqOptions);
  }
}